import SixthSection from "./SixthSection";
import ufs from "../../../assets/warehouse/UFS_log_Orange.svg";

const WhyChooseUs = () => {
  return (
    <SixthSection
      brandImage={ufs}
      brandName="United Freight Solutions?"
      description="Choosing United Freight Solutions (UFS) means partnering with a logistics company that is committed to moving your business forward. Here’s why businesses trust us to handle their most important shipments:"
      subtopic1="Global Expertise: "
      subdes1=" With a logistics network that spans across continents, UFS connects your business to key markets and trade routes around the world. Our global reach ensures that your goods arrive on time, every time, no matter where they’re headed."
      subtopic2="Tailored Solutions: "
      subdes2="Every business is unique, and so are its logistics needs. We offer fully customized shipping solutions designed to meet the specific demands of your supply chain, from urgent air freight to cost-effective sea freight."
      subtopic3="Real-Time Visibility: "
      subdes3="Stay in control with real-time tracking and full visibility of your shipments. Our advanced technology keeps you informed at every step of the journey, ensuring transparency and peace of mind."
      subtopic4="Sustainable Logistics: "
      subdes4="We believe in moving the world responsibly. UFS is committed to reducing our environmental impact through eco-friendly logistics practices, including fuel-efficient transportation and energy-saving warehousing."
      subtopic5=""
      subdes5="At United Freight Solutions, we do more than just move goods—we move your business forward with efficiency, reliability, and care."
    />
  );
};

export default WhyChooseUs;
